/**
 * baseURL 基本接口
 * wsURL 消息推送
 * cloudURL 云服务器
 * fileURL 文档文件转换(文件在线预览)
 * integrationUrl 接口集成接口
 */
export default {
  config() {
    let api = {
      baseURL: process.env.VUE_APP_BASE_URL,
      wsURL: process.env.VUE_APP_WS_URL,
      cloudURL: process.env.VUE_APP_CLOUD_URL,
      fileURL: process.env.VUE_APP_FILE_URL,
      integrationUrl: process.env.VUE_APP_INTEGRATION_URL
    }
    // 先保留
    // if (host === 'cloud') {
    // api = {
    //   baseURL: 'https://gateway.99digtech.com/custom-gateway/',
    //   wsURL: 'wss://push.99digtech.com',
    //   cloudURL: 'https://gateway.99digtech.com/custom-gateway',
    //   fileURL: 'https://view.99digtech.com/onlinePreview',
    //   integrationUrl: 'https://integration.99digtech.com/custom-integration/'
    // }
    // } else if (host === 'cloud_test') {
    // api = {
    //   baseURL: 'https://devgateway.99digtech.com:7004/custom-gateway/',
    //   wsURL: 'ws://devpush.99digtech.com:7003',
    //   cloudURL: 'https://devgateway.99digtech.com:7004/custom-gateway',
    //   fileURL: 'http://devview.99digtech.com:7005/onlinePreview',
    //   integrationUrl: 'http://devintegration.99digtech.com:7007/custom-integration/'
    // }
    // window.CloudAddressFront = 'app.99digtech.com' // 前台地址
    // window.CloudAddressBack = 'http://devgateway.99digtech.com:7004' // 后台服务地址
    // process.env.VUE_APP_ADDRESS_WEB_FORM = 'http://devddp.99digtech.com/dist/H5.html#/' // web表单地址
    // } else {
    // let protocol = window.location.protocol // 协议
    // let host = window.location.hostname // 主机域名或者ip地址
    // let port = window.location.port // 获取端口号
    // let baseURLNew = protocol + '//' + host + ':' + port
    // let intergrationPort = '8888'
    // if (window.systemConfig && window.systemConfig.intergrationPort) {
    //   intergrationPort = window.systemConfig.intergrationPort
    // }
    // api = {
    //   baseURL: baseURLNew + '/custom-gateway/',
    //   cloudURL: 'https://gateway.99digtech.com/custom-gateway/',
    //   fileURL: protocol + '//' + host + ':8886/onlinePreview',
    //   wsURL: 'wss://192.168.1.188:9006',
    //   integrationUrl: protocol + '//' + host + ':' + intergrationPort + '/custom-integration/'
    // }
    // }
    // if (window.localConfigOptions) {
    //   // 如果有本地化配置
    //   api = window.localConfigOptions
    // }
    // if (window.systemConfig && window.systemConfig.intergrationUrl) {
    //   // 系统配置的接口集成
    //   api.integrationUrl = window.systemConfig.intergrationUrl
    // }
    // if (window.systemConfig && window.systemConfig.onlineViewUrl) {
    //   // 系统配置的在线预览
    //   api.fileURL = window.systemConfig.onlineViewUrl
    // }
    return api
  }
}
